import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    createFolder: string;
    createRestrictedFolder: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Tooltip and aria-label for creating a folder */
            createFolder: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectNavigation_CreateFolderButton.createFolder?c=hz1l49khdeht", defaultMessage: "New Folder" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Tooltip and aria-label for creating a restricted folder */
            createRestrictedFolder: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectNavigation_CreateFolderButton.createRestrictedFolder?c=3bkxqej52favx", defaultMessage: "New Restricted Folder" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
